import React, { Component } from "react"
import { connect } from "react-redux"
import { Link } from "react-router"
import Moment from "moment"

import * as actions from "../../actions/notification_show"

export class NotificationShow extends Component {
  componentDidMount() {
    this.props.getNotification(this.props.params.id)
  }

  render() {
    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else if (!this.props.notification.headings.en) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>
            Notification data not available yet. Please try again later.
          </strong>
        </div>
      )
    } else {
      return (
        <div>
          <blockquote className="blockquote">
            <h1>Push Notification Details</h1>
          </blockquote>
          <div className="well">
            <p>
              <strong>Title:</strong> {this.props.notification.headings.en}
              <br />
              <strong>SubTitle:</strong> {this.props.notification.contents.en}
              <br />
              <strong>Notification Type:</strong>{" "}
              {this.props.notification.data.pushType}
            </p>
            <Link to={"/events/" + this.props.notification.data.id}>
              <strong>Related event</strong>
            </Link>
          </div>
          <div className="well">
            <h3>Notification Stats</h3>
            Notification sent on {" "}
            {Moment.unix(this.props.notification.send_after)
              .utc()
              .format("dddd, MMM Do YYYY - h:mm a")}
            <br />
            <span className="tag tag-success">Successfully Delivered</span>
            &nbsp;{this.props.notification.successful}
            <br />
            <span className="tag tag-info">Opened</span>
            &nbsp;{this.props.notification.converted}
            <br />
            <span className="tag tag-danger"> Failed to Deliver</span>
            &nbsp;{this.props.notification.failed}
            <br />
            <span className="tag tag-warning"> Deliveries Remaining</span>
            &nbsp;{this.props.notification.remaining}
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  console.log("state: " + JSON.stringify(state))
  return {
    notification: state.notification.item,
    loading: state.notification.loading
  }
}

export default connect(mapStateToProps, actions)(NotificationShow)



/** WEBPACK FOOTER **
 ** ./src/components/notifications/show.js
 **/